export const capitalize = str => {
  if (!str) return ''
  str = str.toString()
  return str.toUpperCase()
}
